/**
 * Security middleware to detect and block obvious vulnerability scans
 * This runs on every request and filters malicious patterns
 */
export default defineNuxtRouteMiddleware((to) => {
  // Only check apofinder and related routes that are being targeted
  if (!to.path.includes('apofinder') && !to.path.includes('apotheke-finden')) {
    return
  }

  const query = to.query
  const queryString = Object.values(query).join(' ')

  // SQL Injection patterns (PostgreSQL, MySQL, Oracle)
  const sqlInjectionPatterns = [
    /pg_sleep/i,
    /waitfor\s+delay/i,
    /dbms_pipe/i,
    /sleep\s*\(/i,
    /benchmark\s*\(/i,
    /union\s+select/i,
    /or\s+1\s*=\s*1/i,
    /and\s+1\s*=\s*1/i,
    /'\s*or\s*'/i,
  ]

  // Code injection patterns
  const codeInjectionPatterns = [
    /print\s*\(\s*md5/i,
    /assert\s*\(/i,
    /eval\s*\(/i,
    /base64_decode/i,
    /\$\{.*\}/, // Template injection
  ]

  // OAST/callback patterns
  const oastPatterns = [
    /bxss\.me/i,
    /burpcollaborator/i,
    /oastify\.com/i,
    /interact\.sh/i,
  ]

  // Path traversal patterns
  const pathTraversalPatterns = [
    /\.\.\//,
    /%00/, // Null byte
    /%2e%2e/i, // Encoded ../
    /\.\.%2f/i,
  ]

  // Overlong UTF-8 encoding (attack bypass attempts)
  const encodingAttackPatterns = [
    /%c0%ae/i, // Overlong ./
    /%c0%a7/i, // Overlong encoding
    /%c0%a2/i,
    /%252/i, // Double encoding
  ]

  const allPatterns = [
    ...sqlInjectionPatterns,
    ...codeInjectionPatterns,
    ...oastPatterns,
    ...pathTraversalPatterns,
    ...encodingAttackPatterns,
  ]

  // Check if any pattern matches
  const isMalicious = allPatterns.some(pattern => pattern.test(queryString))

  if (isMalicious) {
    onShowLogs(() => console.warn(`[SECURITY] Blocked malicious request to ${to.fullPath}`))

    // Redirect to clean apofinder page instead of processing malicious params
    return navigateTo('/apotheke-finden', { replace: true })
  }

  const numericParams = ['lat', 'lng', 'page']
  for (const param of numericParams) {
    const value = query[param]
    if (value !== undefined) {
      const strValue = String(value)
      // Allow only valid numeric formats (including negative and decimal)
      if (!/^-?\d+(\.\d+)?$/.test(strValue)) {
        onShowLogs(() => console.warn(`[SECURITY] Invalid ${param} parameter: ${strValue.substring(0, 50)}`))
        return navigateTo('/apotheke-finden', { replace: true })
      }
    }
  }
})
